
import { Fragment, useState } from "react";
import ReportOrder from "../ReportOrder/ReportOrder.jsx";
import "./reportDashboard.css" ;
import ReportOrderCompany from "../ReportOrderCompany/ReportOrderCompany.jsx";




export default function ReportDashboard() {
   const [saveMethod , setSaveMethod] = useState("pdf") ;

   return (
      <Fragment>
         <div className="container">
            <div className="row">
               <form action="" className="d-flex justify-content-around align-items-center">

                  <div>
                     <label htmlFor="createPDF">Create PDF</label>
                     <input type="radio" checked onChange={()=>{setSaveMethod("pdf")}} name="method" id="createPDF" />
                  </div>

                  <div>
                     <label htmlFor="createExcel">Create EXCEL</label>
                     <input type="radio" onChange={()=>{setSaveMethod("excel")}} name="method" id="createExcel" />
                  </div>

               </form>
            </div>

            <div className="row">

               <div className="col-md-4">
                  <div>
                     <button className="btn bg-main text-center w-100 py-3 my-2 d-flex justify-content-between align-items-center" data-bs-toggle="modal" data-bs-target="#ReportOrder">
                           <i class="fa-solid fa-truck "></i>   <span>تقارير الطلبات </span>
                     </button>
                     <ReportOrder saveMethod={saveMethod}/>
                  </div>
               </div>

               <div className="col-md-4">
                  <div>
                     <button className="btn bg-main text-center w-100 py-3 my-2 d-flex justify-content-between align-items-center" data-bs-toggle="modal" data-bs-target="#ReportOrderCompany">
                           <i class="fa-regular fa-building"></i>  <span>تقارير الشركات </span>
                     </button>
                     <ReportOrderCompany saveMethod={saveMethod}/>
                  </div>
               </div>

               <div className="col-md-4">
                  <div>
                     <button disabled className="btn bg-main text-center w-100 py-3 my-2 d-flex justify-content-between align-items-center">
                           <i class="fa-solid fa-flask-vial"></i>   <span>تقارير الخدمات  واسعارها </span>
                     </button>
                  </div>
               </div>

               <div className="col-md-4">
                  <div>
                     <button disabled className="btn bg-main text-center w-100 py-3 my-2 d-flex justify-content-between align-items-center">
                              <i class="fa-solid fa-bed-pulse"></i>  <span>تقارير المرضى </span>
                     </button>
                  </div>
               </div>

               <div className="col-md-4">
                  <div>
                     <button disabled className="btn bg-main text-center w-100 py-3 my-2 d-flex justify-content-between align-items-center">
                           <i class="fa-solid fa-users"></i>   <span> تقارير المستخدمين </span>
                     </button>
                  </div>
               </div>

            </div>
         </div>
      </Fragment>
   )
}


























































// import axios from "axios";
// import { useContext, useEffect, useRef, useState } from "react";
// import { CompanyContext } from "../../../Context/CompanyContext.js";
// import { Fragment } from "react";
// import "./ReportDashboard.css"
// import { UserContext } from "../../../Context/UserContext.js";
// import { toast } from "react-toastify";




// export default function ReportDashboard() {
//    const {allCompanyInfo , getAllCompanyInfo} = useContext(CompanyContext) ;
//    const {userToken} = useContext(UserContext) ;
//    const inputCompany = useRef(null) ;


//    const [btnLoading , setBtnLoading] = useState(false) ;
//    const [start , setStart] = useState("") ;
//    const [end , setEnd] = useState("") ;
   
//    const [companyId ,setCompanyId] = useState("") ;
//    const [checkedCompany , setCheckedCompany] = useState(false) ;
   

   

//    const inputDay = useRef(null) ;
   

//    const inputMonth = useRef(null) ;
   

//    const inputYear = useRef(null) ;
   
//    const [patient , setPatient] = useState("") ;
//    const [checkedPatient , setCheckedPatient] = useState(false) ;
//    const inputPatient = useRef(null) ;
   
//    const header = {
//       token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token") }` 
//    } ;
   




//    async function getAllOrders(){
//       console.log();
      
//       // setBtnLoading(true)
//       // await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/report` , 
//       //    {
//       //       start:start || undefined , 
//       //       end : end || undefined , 
//       //       company_id : companyId || undefined , 
//       //       patient: patient || undefined , 
//       //    } ,  {headers:header}
//       // )
//       // .then(({data})=>{
//       //    if(data.message === "success"){
//       //       console.log(data.pathFile);
            
//       //       // Swal.fire({
//       //       //    title: "Please Wait Seconds",
//       //       //    html: "Creating The PDF File After <b></b> milliseconds." ,
//       //       //    timer: 3000 ,
//       //       //    timerProgressBar: true ,
//       //       //    didOpen: () => {
//       //       //       Swal.showLoading() ;
//       //       //       const timer = Swal.getPopup().querySelector("b") ;
//       //       //       setInterval(() => {
//       //       //          timer.textContent = `${Swal.getTimerLeft()}` ;
//       //       //       }, 100);
//       //       //    },
//       //       // });
//       //       // setTimeout( () => {

//       //          // }, 2000); 


//       //          try {
//       //             // window.open(data.pathFile, '_blank');
//       //             window.open(data.pathFile, '_blank', 'noopener,noreferrer');
//       //             setBtnLoading(false)
//       //          } catch (error) {
//       //             console.log(error);
                  
//       //          }
//       //       }
//       //    })
//       //    .catch((error)=>{
//       //       setBtnLoading(false)
//       //       toast.error(error.response.data.message)
//       // });
//    }





//    function handleCheckCompany(checked){
//       setCheckedCompany(checked) ;
//       setCompanyId(undefined)
//       inputCompany.current.value = "Select Company"
//    }


//    function handleCheckPatient(checked){
//       setCheckedPatient(checked) ;
//       setPatient(undefined) ;
//       inputPatient.current.value = undefined
//    }


//    useEffect(() => {
//       getAllCompanyInfo()
//    })

//    return (
//       <Fragment>
//          <div className="container">
//             <form action="" className="form-control mt-5">
//                <div className="d-table w-100">

//                   {/* Row 2: From Date */}
//                   <div className="d-table-row">
//                      <div className="d-table-cell px-2 py-2">
//                         <label htmlFor="start" className="col-form-label">From</label>
//                      </div>
//                      <div className="d-table-cell px-2 py-2">
//                         <input type="date"  id="start" className="form-control" onChange={(e) => setStart(e.target.value)}/>
//                      </div>
//                   </div>

//                   {/* Row 3: To Date */}
//                   <div className="d-table-row">
//                      <div className="d-table-cell px-2 py-2">
//                         <label htmlFor="end" className="col-form-label">To</label>
//                      </div>
//                      <div className="d-table-cell px-2 py-2">
//                         <input type="date" id="end" className="form-control"onChange={(e) => setEnd(e.target.value)}/>
//                      </div>
//                   </div>


                  
//                   {/* Row 1: Choose Company */}
//                   <div className="d-table-row">
//                      <div className="d-table-cell px-2 py-2">
//                         <label htmlFor="company" className="col-form-label">Choose Company</label>
//                      </div>
//                      <div className="d-table-cell px-2 py-2">
//                         <select  ref={inputCompany} disabled={!checkedCompany} name="company" id="company" className="form-control" onChange={(e) => setCompanyId(e.target.value)}>
//                            <option>Select Company</option>
//                            {allCompanyInfo.length > 0 ? allCompanyInfo.map((ele) => (
//                               <option key={ele._id} value={ele._id}>{ele.name}</option>
//                            )) : ""}
//                         </select>
//                      </div>
//                      <div className="d-table-cell px-2 py-2">
//                         <input type="checkbox"  onChange={(e)=>handleCheckCompany(e.target.checked)}/>
//                      </div>
//                   </div>

//                   {/* Row 7: Patient */}
//                   <div className="d-table-row">
//                      <div className="d-table-cell px-2 py-2">
//                         <label htmlFor="patient" className="col-form-label">Patient</label>
//                      </div>
//                      <div className="d-table-cell px-2 py-2">
//                         <input
//                            type="text"
//                            ref={inputPatient}
//                            disabled={!checkedPatient} 
//                            id="patient"
//                            className="form-control"
//                            placeholder="Phone Or Name"
//                            onChange={(e) => setPatient(e.target.value)}
//                         />
//                      </div>
//                      <div className="d-table-cell px-2 py-2">
//                         <input type="checkbox" onChange={(e)=>handleCheckPatient(e.target.checked)}/>
//                      </div>
//                   </div>
//                </div>

//             </form>

//             <div className="text-center">
//             {btnLoading? 
//                   <button className="btn bg-main text-center w-50 my-2">
//                      Loading ...<i className="fa-solid fa-print mx-2"></i>
//                   </button> 
//                : 
//                   <button onClick={()=>{getAllOrders()}} className="btn bg-main text-center w-50 my-2">
//                      طباعة التقرير  <i className="fa-solid fa-print mx-2"></i>
//                   </button>
//             }

//             </div>
//          </div>
//       </Fragment>
//    )
// }
